module.exports = __webpack_public_path__ + "media/step-4.bec31ff4.mp4";